import { render, staticRenderFns } from "./SaveAsPreset.vue?vue&type=template&id=6e66583c&scoped=true"
import script from "./SaveAsPreset.vue?vue&type=script&lang=js"
export * from "./SaveAsPreset.vue?vue&type=script&lang=js"
import style0 from "./SaveAsPreset.vue?vue&type=style&index=0&id=6e66583c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e66583c",
  null
  
)

export default component.exports